module.exports = __webpack_public_path__ + "static/media/defaultthumbnail.70563928.png";